import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { FormGroup } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowFile } from 'app/models/workflow-file';
import { CloudPickedFile } from 'app/models/picked-file';

@Component({
  selector: 'app-add-edit-workflow-file',
  templateUrl: './add-edit-workflow-file.component.html',
  styleUrls: ['./add-edit-workflow-file.component.scss']
})
export class AddEditWorkflowFileComponent implements OnInit {

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() isEdit: boolean;
  @Input() parentsFiles: WorkflowFile[] = [];
  @Input() enableDuplicateFileOption: boolean = false;

  workflowFileToAddFormGroup: FormGroup;

  @ViewChild('addEditFileModal', { static: true }) addEditFileModal: ModalDirective;
  
  constructor(private validationHandler: ValidationHandler) { }

  ngOnInit(): void {
  }

  show(frm: FormGroup) {
    this.workflowFileToAddFormGroup = frm;
    this.addEditFileModal.show();
  }

  onAddWorkflowFileClick() {
    this.validationHandler.onSubmitCheck(this.workflowFileToAddFormGroup);
    if(!this.workflowFileToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.workflowFileToAddFormGroup);
    this.addEditFileModal.hide();
  }

  onPickedAttachedFile(e) {
    let storageId: number = (e[0] as CloudPickedFile).storageId;
    let filePath: string = (e[0] as CloudPickedFile).path;

    this.workflowFileToAddFormGroup.get('attached_storage_id').setValue(storageId);
    this.workflowFileToAddFormGroup.get('attached_file_path').setValue(filePath);
  }
}
